import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-1 rounded-xl bg-secondary text-white px-3 py-1 mb-1 ml-1 text-left" }

import { XIcon } from '@heroicons/vue/solid';


export default /*#__PURE__*/_defineComponent({
  props: { text: String },
  emits: ['remove'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(__props.text), 1),
    _createElementVNode("div", {
      class: "flex-shrink-0 w-4 h-4 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove')))
    }, [
      _createVNode(_unref(XIcon))
    ])
  ]))
}
}

})